export const FAVORITES_STORAGE_KEY = '@eskolare/menu-favorites';

export function buildMenuKey({ sectionKey, parentKey, title, id }) {
  const name = id || title;

  return parentKey ? `${parentKey}/${name}` : `${sectionKey}/${name}`;
}

export function isItemVisible(item, isStaff) {
  return (!item.isStaff && !item.invisible) || (item.isStaff && isStaff);
}

export function buildFavoriteCatalog(sections, isStaff) {
  const catalog = {};

  sections
    .filter(section => isItemVisible(section, isStaff))
    .forEach((section, sectionIndex) => {
      const sectionKey = [section.subheader || 'subheader', sectionIndex.toString()].join('-');

      const walk = (menuItems, parentKey = '', parentTitle = '') => {
        menuItems
          .filter(item => isItemVisible(item, isStaff))
          .forEach(item => {
            const menuKey = buildMenuKey({
              sectionKey,
              parentKey,
              title: item.title,
              id: item.menuKey,
            });
            const fullTitle = parentTitle ? `${parentTitle} › ${item.title}` : item.title;

            if (item.items) {
              if (Array.isArray(item.items)) {
                walk(item.items, menuKey, fullTitle);
              }
              return;
            }

            if (item.href && item.favoriteable !== false) {
              catalog[menuKey] = {
                menuKey,
                title: item.title,
                fullTitle,
                href: item.href,
                icon: item.icon,
                target: item.target,
                disabled: item.disabled,
                isNew: item.isNew,
                isStaff: item.isStaff,
                info: item.info,
              };
            }
          });
      };

      if (Array.isArray(section.items)) walk(section.items);
    });

  return catalog;
}

export function getFavoriteEntries(favoriteKeys, sections, isStaff) {
  const catalog = buildFavoriteCatalog(sections, isStaff);

  return favoriteKeys.map(menuKey => catalog[menuKey]).filter(Boolean);
}

export function sanitizeFavoriteKeys(favoriteKeys, sections, isStaff) {
  const catalog = buildFavoriteCatalog(sections, isStaff);
  return favoriteKeys.filter(menuKey => catalog[menuKey]);
}

export function getFavoriteDisplay(entry) {
  if (entry.icon) {
    return { title: entry.title, icon: entry.icon };
  }

  return { title: entry.fullTitle, useChevronIcon: true };
}
